import { render } from "./song-card-text.vue?vue&type=template&id=5b0d81cc&ts=true"
import script from "./song-card-text.vue?vue&type=script&lang=ts"
export * from "./song-card-text.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__